const newCaseCardStyle = {
  cardContainer: {
    width: "100%",
  },
};

export default newCaseCardStyle;
